/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {useRefresh} from '@ion/dls/src/hooks/useRefresh';

/**
 * Provides a utility hook setting to true then, after delay, resetting the
 * refresh state to false.
 *
 * ```typescript
 *   const SomeComponent = () => {
 *     const refresh = useRefresh();
 *   }
 *
 * ```
 */
export const useGroupRefresh = () => {
  const {globalGroup} = useSelector(({globalGroup}) => globalGroup);
  const refreshGrid   = useRefresh(globalGroup);
  return refreshGrid;
};

export default useGroupRefresh;
